export const TIMELINE_CHOICES = [
  { value: 'specific_date', text: 'Yes, I have a specific date' },
  { value: 'soon_next_1_to_2_months', text: 'No specific date, but soon (in the next 1-2 months)' },
  { value: 'soon_within_6_months', text: 'No specific date, but sometime in the next 6 months' },
  { value: 'within_12_months', text: 'Within the next 12 months' },
  { value: 'over_a_year_from_now', text: 'Over a year from now' },
  { value: 'just_looking', text: 'I\'m just looking for now' },
]

export const RECIPIENT_CHOICES = [
  { value: 'S/O', text: 'My significant other' },
  { value: 'me', text: 'Me' },
]

export const INTENT_CHOICES = [
  { value: 'shopping_around', text: 'Shopping around' },
  { value: 'buy_my_own', text: 'Planning to buy my own ring' },
  { value: 'shopping_together', text: 'My S/O and I are shopping together' },
]

export const SHIPPING_COUNTRY_CHOICES = [
  { value: 'United States', text: 'United States' },
  { value: 'Canada', text: 'Canada' },
  { value: 'United Kingdom', text: 'United Kingdom' },
  { value: 'Australia', text: 'Australia' },
  { value: 'Other', text: 'Other' },
]
